import { HOLD_RANKS } from 'constants/enum';
import { isHoldRank } from './AgentRankTabs';

export const AGENT_STATUS_LABELS = {
  hold: 'On hold',
  holdCompliance: 'On hold',
  offboarding: 'Offboarding',
  active: 'Active',
  inactive: 'Inactive'
};

export function getAgentStatus(agent, openOffboardingRecord = null) {
  if (openOffboardingRecord && !openOffboardingRecord.canOffboard) {
    return 'offboarding';
  }
  if (HOLD_RANKS.has(agent.rank)) {
    return agent.rank === 'Compliance Hold' ? 'holdCompliance' : 'hold';
  }
  if (agent.rank === 'Inactive') return 'inactive';
  return 'active';
}

export function getOpenOffboardingRecord(openOffboardingAgencies, agent) {
  return (
    openOffboardingAgencies?.[String(agent.Agency_Id)]?.agents?.[
      String(agent.id)
    ] ?? null
  );
}

export function getAgentStatusLabel(agent, openOffboardingRecord = null) {
  if (isHoldRank(agent.rank)) return agent.rank;
  return AGENT_STATUS_LABELS[getAgentStatus(agent, openOffboardingRecord)];
}
